import { contracts } from '../../data/contracts'

export default {
	id: 3,
	name: 'OLAND - WATER',
	deposit: '0',
	pair: {
		token0: {
			name: 'OLAND',
			symbol: 'OLAND',
			address: contracts[process.env.REACT_APP_NETWORK].olandAddress,
			logo: 'tokens/Oland.png'
		},
		token1: {
			name: 'WATER',
			symbol: 'OWATER',
			address: contracts[process.env.REACT_APP_NETWORK].waterAddress,
			logo: 'tokens/OWater.png'
		},
		address: contracts[process.env.REACT_APP_NETWORK].DEX.Pairs.OLAND_Water
	}
}
